import { render, staticRenderFns } from "./statusUpdate.vue?vue&type=template&id=4c588729&"
import script from "./statusUpdate.vue?vue&type=script&lang=js&"
export * from "./statusUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports